import { render, staticRenderFns } from "./labelManager.vue?vue&type=template&id=23b1b964&scoped=true"
import script from "./labelManager.vue?vue&type=script&lang=js"
export * from "./labelManager.vue?vue&type=script&lang=js"
import style0 from "./labelManager.vue?vue&type=style&index=0&id=23b1b964&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b1b964",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b1b964')) {
      api.createRecord('23b1b964', component.options)
    } else {
      api.reload('23b1b964', component.options)
    }
    module.hot.accept("./labelManager.vue?vue&type=template&id=23b1b964&scoped=true", function () {
      api.rerender('23b1b964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/shop/labelManager.vue"
export default component.exports